/**
 * api接口的统一出口
 */
import user from '@/api/user';
import resource from '@/api/resource';
import verify from '@/api/verify';
import vendor from '@/api/vendor';
import ecert from '@/api/ecert';
import appendix from '@/api/appendix';
import users from '@/api/users';
import special from '@/api/special';
import useCharge from '@/api/useCharge';
import invoice from '@/api/invoice';
import order311 from '@/api/311order';
import storder from '@/api/storder';
import ckorder from '@/api/ckorder';
import vendorMgr from '@/api/vendorMgr';
import excel from '@/api/excel';
import lastorder from '@/api/lastorder';
import syslog from '@/api/syslog';
import delivery from '@/api/delivery';
import transferbills from '@/api/transferbills';
import itemSalesStock from '@/api/itemSalesStock';
import inShop from '@/api/inShop';
import businessCalendar from '@/api/businessCalendar';
import businessNotice from '@/api/businessNotice';
import maker from '@/api/maker';
import common from '@/api/common';
import itembl from '@/api/itembl';
import itemQuery from '@/api/itemQuery';
import itemHis from '@/api/itemHis';
import otherSkip from '@/api/otherSkip';
import commodity from '@/api/commodity';
import userGroupMenu from '@/api/userGroupMenu';
// 其他模块的接口……

// 导出接口
export default {
  user,
  users,
  resource,
  verify,
  vendor,
  ecert,
  appendix,
  special,
  useCharge,
  invoice,
  order311,
  storder,
  ckorder,
  vendorMgr,
  excel,
  lastorder,
  syslog,
  delivery,
  transferbills,
  itemSalesStock,
  inShop,
  businessCalendar,
  businessNotice,
  maker,
  common,
  itembl,
  itemQuery,
  itemHis,
  otherSkip,
  commodity,
  userGroupMenu,
}



// WEBPACK FOOTER //
// ./src/api/index.js